import { Bank, Check2, ChatLeftText, QuestionCircle, PencilSquare, CheckSquare } from "react-bootstrap-icons";

// One visual language per notification type, using the same react-bootstrap-icons + colour-chip
// convention as the activities feed (see ActivityPanel's ICONS) so a concept reads identically
// wherever it appears in the app.
export const notificationVisual = (type) => {
  switch (type) {
    case "AllPayments":
    case "CustomerPayments":
    case "TerminalPayments":
    case "MyRequests":
      // A payment landed — same glyph/palette as an activity-feed payment.
      return { Icon: Check2, chip: "bg-green-50 text-green-600" };
    case "Payouts":
      return { Icon: Bank, chip: "bg-sky-50 text-sky-600" };
    case "CustomerQueries":
      // Matches the activity feed's query identity.
      return { Icon: QuestionCircle, chip: "bg-violet-50 text-violet-600" };
    case "NoteTagged":
      // Same pencil glyph + zinc palette as a note in the activity feed (NoteCreated).
      return { Icon: PencilSquare, chip: "bg-zinc-100 text-zinc-600" };
    case "TaskAssigned":
      // Same check-square glyph + slate palette as a task in the activity feed (TaskCreated).
      return { Icon: CheckSquare, chip: "bg-slate-100 text-slate-700" };
    default:
      return { Icon: ChatLeftText, chip: "bg-zinc-100 text-zinc-500" };
  }
};
